// ユーティリティ関数: バイトサイズを人間に読みやすい文字列に変換
export function formatBytes(bytes: number | undefined, decimals: number = 2): string {
  if (bytes === undefined) return '-'
  if (bytes === 0) return '0 B'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export function formatDateTime(date: string | Date | undefined): string {
  if (date === undefined) return '-'
  return new Date(date).toLocaleString().replace(/-/g, '/') // 2021-01-01 -> 2021/01/01
}

// こちらは日付のみを表示
export function formatDate(date: string | Date | undefined): string {
  if (date === undefined) return '-'
  return new Date(date).toLocaleDateString().replace(/-/g, '/') // 2021-01-01 -> 2021/01/01
}

export function formatFloat(value: number | undefined, decimals: number = 2): string {
  if (value === undefined) return '-'
  return value.toFixed(decimals)
}
